module.exports = __webpack_public_path__ + "img/logo-footer.2a496b3.png";